import { Box, Card } from '@palmetto/palmetto-components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';

import { AdminTaskMap, AdminTask } from 'types';

import { AddFEOCException } from './AddFEOCException';
import { AvlImport } from './AvlImport';
import { BulkEnrollDomesticContent } from './BulkEnrollDomesticContent';
import { BulkMoveToStrandedAssetTeam } from './BulkMoveToStrandedAssetTeam';
import { GrantPtoGreenlight } from './GrantPtoGreenlight';
import { OrganizationUserExport } from './OrganizationUserExport';
import { OrganizationVisibility } from './OrgVisibility';
import { ReplayFailedConcordLogs } from './ReplayFailedConcordLogs';
import { ReplayFailedDirectPayLogs } from './ReplayFailedDirectPayLogs';

export const Task = () => {
  const { taskType = AdminTask.grantPtoGreenlight } = useParams<{ taskType: AdminTask }>();
  const { ptoGreenlight = false, replayFailedDirectPayLogsFlag = false } = useFlags();

  return (
    <Card padding="sm">
      <Card.Header>
        <Box direction="row" justifyContent="space-between">
          <Box fontSize={taskType === AdminTask.replayFailedDirectPayLogs ? 'xl' : 'md'} fontWeight="medium">
            {AdminTaskMap[taskType]?.title}
          </Box>
        </Box>
      </Card.Header>
      {renderTaskComponent(taskType, ptoGreenlight, replayFailedDirectPayLogsFlag)}
    </Card>
  );
};

const renderTaskComponent = (
  taskType: AdminTask,
  ptoGreenlight: boolean,
  replayFailedDirectPayLogsFlag: boolean,
) => {
  switch (taskType) {
    case 'bulkEnrollDomesticContent':
      return <BulkEnrollDomesticContent />;
    case 'orgVisibility':
      return <OrganizationVisibility />;
    case 'grantPtoGreenlight':
      return ptoGreenlight ? <GrantPtoGreenlight /> : null;
    case 'organizationUserExport':
      return <OrganizationUserExport />;
    case 'avlImport':
      return <AvlImport />;
    case 'addFeocException':
      return <AddFEOCException />;
    case 'moveToStrandedAssetTeam':
      return <BulkMoveToStrandedAssetTeam />;
    case 'replayFailedDirectPayLogs':
      return replayFailedDirectPayLogsFlag ? <ReplayFailedDirectPayLogs /> : null;
    case 'replayFailedConcordLogs':
      return <ReplayFailedConcordLogs />;
    default:
      return null;
  }
};
